module.exports = __webpack_public_path__ + "img/share_icon.5f78475b.svg";